export const BREAKPOINTS = {
  xs: 0,
  sm: 600,
  md: 840,
  lg: 1200,
  xl: 1600,
}

export const BOTTOM_NAVIGATION_ELEMENT_ID = 'bottom-navigation'
export const TOOLBAR_ELEMENT_ID = 'toolbar'
export const TTS_PLAYER_ELEMENT_ID = 'tts-player'
export const LAYOUT_ELEMENT_ID = 'layout'
export const MAIN_ELEMENT_ID = 'main'
export const HEADER_TITLE_ELEMENT_ID = 'header-title'
export const HEADER_ACTIONS_ELEMENT_ID = 'header-actions'
export const HEADER_MENU_ELEMENT_ID = 'header-menu-element'
export const HEADER_MENU_PANEL_ELEMENT_ID = 'header-menu-panel'
export const NAVIGATION_TABS_ELEMENT_ID = 'navigation-tabs'
export const TILES_ELEMENT_ID = 'tiles'
export const CHAT_FAB_ELEMENT_ID = 'chat-fab'
